/*global $*/
/*eslint no-undef: "error"*/
export default class Show {
    classItem = 'show--item'
    classButton = 'show--button'
    classOpen = 'show---open'

    constructor () {
        let self = this

        $(`.${self.classButton}`).click(function () {
            $(this).closest(`.${self.classItem}`).addClass(self.classOpen)
        })
    }
}
